<template>
    <div>
        <label for="coverageType">Coverage Type</label>
        <select id="coverageType" v-model="valueCopy" class="form-control">
            <option v-for="coverage in coverages" :value="coverage.coverageLevelId">
                {{coverage.text}}
            </option>
        </select>
    </div>
</template>

<script>
    import {configTables} from "../../global/configTables.js";

    export default {
        name: "AcCoverageDropDown",
        props: {
            value: {
                required: true, validator: function (val) {
                    return val == null || (typeof val === "number");
                }
            }
        },
        data() {
            return {
                valueCopy: this.value,
                coverages: []
            };
        },
        async mounted() {
            if (!this.value) {
                this.valueCopy = 1;
            }
            let coverageOptions = await configTables.getCoverageOptions();
            this.coverages = coverageOptions;
        },
        watch: {
            value(originalUpdated) {
                //console.log("original phone number has been updated", originalUpdated);
                this.valueCopy = originalUpdated;
            },
            valueCopy(selectedCoverage) {
                //console.log("phone number has been updated: ", cleanPhoneNumber);
                this.$emit('input', selectedCoverage);
            }
        }
    }
</script>

<style scoped>

</style>